/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntityId } from './entityId';
import { HealthLevel } from './healthLevel';


/**
 * Entity Id Object
 */
export interface EntityInfo { 
    entity_id: EntityId;
    level?: HealthLevel;
    name: string;
    newest_sensor_ts?: number;
    oldest_sensor_ts?: number;
}
export namespace EntityInfo {
}


